import { STANDARD_BRANCH } from '@festina-life/api'
import { assertNotEmpty } from '@festina-life/core'
import { useCallback } from 'react'

import { useAllConciseBranches } from '../../../uiModels/branches/useAllConciseBranches'
import { getBranchServerFromPath } from './helpers'

export const useConciseBranchFromPath = () => {
  const conciseBranches = useAllConciseBranches()

  return useCallback(
    ({
      fullPath,
      isWorkspacePath,
    }: {
      fullPath: string[]
      isWorkspacePath: boolean
    }) => {
      const path = isWorkspacePath ? fullPath.slice(0, -1) : fullPath
      if (path.length <= 1) {
        return
      }

      const nodeServer = getBranchServerFromPath(path)
      const branchName = path.at(path.length - 1)

      assertNotEmpty(nodeServer)

      return branchName !== STANDARD_BRANCH
        ? conciseBranches[nodeServer]?.find(
            (specification) => specification.name === branchName,
          )
        : undefined
    },
    [conciseBranches],
  )
}
